import { BabylonState } from "../state";

export function resize(state: BabylonState) {
  state.context.engine.resize();
}
